import React, { useEffect } from 'react';
import Breadcrumb from '../../../shared-components/Breadcrumb/Breadcrumb';
import { ThingsToDo } from '../ThingsToDo';
import { useRouter } from 'next/router';

interface IProps {
  cityName: string | undefined;
  citySlug: string | undefined;
}

export const Header = ({ cityName, citySlug }: IProps) => {
  const breadcrumbLinks = [
    { title: 'Home', hrefLink: '/' },
    {
      title: cityName ? cityName : 'City',
      hrefLink: `${citySlug ? `/${citySlug}` : `/`}`
    },
    {
      title: `Things to do in ${cityName}`,
      hrefLink: `${citySlug ? `/${citySlug}/things-to-do-in-${citySlug}` : `/`}`
    }
  ];
  return (
    <div className="flex flex-col gap-3 py-6 sm:py-10 mx-5 items-start sm:items-center">
      <h1 className="font-semibold text-[22px] leading-7 sm:text-[28px] sm:leading-9 xl:text-4xl xl:leading-10">
        Things to do in {cityName}
      </h1>
      <Breadcrumb
        breadcrumbLinks={breadcrumbLinks}
        activeLinkColor="darkBlue"
      />
    </div>
  );
};
